import { render, staticRenderFns } from "./Setup_ClientEdit.vue?vue&type=template&id=1a12ed1a&"
import script from "./Setup_ClientEdit.vue?vue&type=script&lang=js&"
export * from "./Setup_ClientEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports